<p>
  verify-user-email works!
</p>
